import { useCallback, useEffect, useState } from "react";
import { clientConstantsServiceInstance } from "../../../../legacy/services/client-constants/client-constants.service.instance";
import type { ReplaceSinglePlaceholderProps } from "../../../../legacy/services/client-constants/client-constants.service.interface";
import { GENERAL_SUBSCRIPTION_TO_BONUSX_SUBSCRIPTION_TIER_MAP } from "../../../../legacy/services/user-subscription/enums/bonusx-subscription-tiers.enum";
import { CHATBOT_NAME } from "../../../../features/ai-chatbot/constants/chatbot-name.const";
import { useCurrentUserSubscriptionTier } from "../../use-current-user-subscription-tier/use-current-user-subscription-tier";
import { useFormValues } from "../../useFormValues";
import { ClientConstantsReplacementsManager } from "./replacements-manager/replacements-manager";

const replacementsManager = new ClientConstantsReplacementsManager();

export function useClientConstantsReplacements() {
  const { Nome } = useFormValues();
  const { translationKeyForTier, currentUserTier } = useCurrentUserSubscriptionTier();

  const currentUserTierAsBonusxSubscriptionTier = GENERAL_SUBSCRIPTION_TO_BONUSX_SUBSCRIPTION_TIER_MAP[currentUserTier];

  const [replacements, setReplacements] = useState<ReplaceSinglePlaceholderProps[]>([]);

  const revalidateReplacements = useCallback(() => {
    const newReplacements = replacementsManager.getReplacements({
      chatbotName: CHATBOT_NAME,
      userFirstName: Nome ?? "",
      currentUserTier: currentUserTierAsBonusxSubscriptionTier,
      translationKeyForTier,
    });
    setReplacements(newReplacements);
  }, [Nome, currentUserTierAsBonusxSubscriptionTier, translationKeyForTier]);

  useEffect(
    function updateReplacementsInService() {
      clientConstantsServiceInstance.placeholdersReplacements = replacements;
    },
    [replacements]
  );

  useEffect(
    function updateReplacements() {
      revalidateReplacements();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [Nome, currentUserTier, translationKeyForTier]
  );

  return {
    replacements,
    revalidateReplacements,
  };
}
